import posthog from "posthog-js";

const ok = () => {
  try { return posthog && posthog.__loaded; } catch { return false; }
};

export const analytics = {
  capture(event, props = {}) {
    if (ok()) posthog.capture(event, props);
  },
  identify(id, props = {}) {
    if (ok() && id) posthog.identify(String(id), props);
  },
  reset() {
    if (ok()) posthog.reset();
  },
};

export default analytics;
